<template>
    <div class="select" :class="{ 'is-open': isOpen }" v-click-outside="close">
        <div class="select-button" @click="toggle">
            <div class="select-button-text" v-text="selected"></div>
            <button>
                <figure>
                    <span class="inline-svg" style="padding-top: 58.82%;"><select-arrow /></span>
                </figure>
            </button>
        </div>
        <ul class="select-list">
            <li class="select-item" v-for="(option, index) in options" :key="index" :class="{ 'is-active': option.value == value }">
                <span class="select-value" v-text="option.name" @click="updateValue(option.value)"></span>
            </li>
        </ul>
        <input type="hidden" :name="name" :value="value">
    </div>
</template>
<script>
import ClickOutside from 'vue-click-outside'

export default {
    directives: {
        ClickOutside,
    },
    props: {
        name: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            required: true
        },
        options: {
            type: Array,
            required: true
        },
        value: {
            type: String,
            required: false
        }
    },
    mounted() {
        if (this.value) {
            const selected = this.options.find(option => option.value === this.value)
            this.selected = selected.name
        } else {
            this.selected = this.placeholder
        }
    },
    data: () => ({
        isOpen: false,
        selected: null,
        popperOptions: {
            placement: 'bottom',
            modifiers: { 
                offset: {
                    offset: '0, 10px'
                } 
            }
        }
    }),
    methods:  {
        toggle() {
            this.isOpen = !this.isOpen
        },
        close() {
            this.isOpen = false
        },
        updateValue(value) {
           this.$emit('input', value)
           this.isOpen = false

            const selected = this.options.find(option => option.value === value)
            this.selected = selected.name
        }
    }
}
</script>